<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-inner table-condensed table-striped">
        <tbody>
          <tr>
            <th role="columnheader" aria-label="Containing Latex?" class="col-sm-4">
              Containing Latex?
            </th>
            <th role="columnheader" aria-label="MRI Safety Status" class="col-sm-4">
              MRI Safety Status
            </th>
            <th role="columnheader" aria-label="Device labeled as not made with natural rubber latex?" class="col-sm-4">
              Device labeled as not made with natural rubber latex?
            </th>
          </tr>
          <tr>
            <td role="gridcell" aria-label="Cell of Containing Latex?">
              <label controlName="containingLatex"> </label>
            </td>
            <td role="gridcell" aria-label="Cell of MRI Safety Status">
              <label controlName="mriSafetyStatus"> </label>
            </td>
            <td role="gridcell" aria-label="Cell of Device labeled as not made with natural rubber latex?">
              <label controlName="labeledAsNotMadeWithNaturalRubber"> </label>
            </td>
          </tr>
        </tbody>
      </table>

    </form>
  </div>
</div>
